import { createContextProvider } from "../components/store-utils";
import { DetailReport } from "./models"

export type DetailAction = {type: "setReport", report: DetailReport} | {type: "setPeriod", period:string}
export type DetailState = {report?: DetailReport, account?:number, period?:string}

function reducer(state: DetailState, action: DetailAction):DetailState{
    switch(action.type){
        case "setReport": return {...state, report: action.report}
        case "setPeriod": return {...state, period: action.period}
        default: return state;
    }
}

export const [AdDetailContext, AdDetailStore] = createContextProvider(reducer, {});